<div class="widget-card gauge-kpi-widget" [ngClass]="widthClass">
  <div class="widget-header">
    <span class="title-text">{{ widgetTitle }}</span>
    <gains-ellipsis-menu *ngIf="menuItems.length > 0" class="ellipsis-button" [menuItems]="menuItems" (changeEvent)="handleMenuAction($event)"> </gains-ellipsis-menu>
  </div>

  <div class="gauge-container">
    <div class="gauge-wrapper">
      <gauge-svg
        [gaugeSize]="gaugeSize"
        [strokeWidth]="strokeWidth"
        [backgroundPath]="getArcPath(180, 360)"
        [arcs]="getGaugeArcPaths()">
      </gauge-svg>

      <div class="gauge-metric">
        <span class="gauge-value">{{ getFormattedValue() }}</span>
        <span class="gauge-description">{{ description }}</span>
      </div>
    </div>
  </div>
</div>
